import Vue from "vue";
import Router from "vue-router";

import SubscriberDashboard from "@/components/subscriber/dashboard/index.vue";
import AdminDashboard from "@/components/admin/dashboard/index.vue";
import LoginPage from "@/components/auth/login.vue";
import Login from "@/components/auth/login.vue";
import ResetPassword from "@/components/auth/reset.vue";
import Register from "@/components/auth/register.vue";
import CustomerRegister from "@/components/auth/customer-register.vue";
import CustomerLogin from "@/components/auth/customer-login.vue";

import CreateOrder from "@/components/subscriber/orders/_pages/create.vue";
import SubmitOrder from "@/components/subscriber/orders/_pages/raise-order.vue";
import CategoryProducts from "@/components/subscriber/orders/_pages/products.vue";
import PendingOrders from "@/components/subscriber/orders/index.vue";
import CustomerOrderView from "@/components/subscriber/orders/_pages/view.vue";
// auth routes

// admin routes
import SubscribersRoutes from "@/components/admin/subscribers/router";
import PaymentsRoutes from "@/components/admin/payments/router";
import AllShopsRoutes from "@/components/admin/shops/router";

import ProductsRoutes from "@/components/subscriber/products/router";
import PurchasesRoutes from "@/components/subscriber/purchases/router";
import SaleDocumentsRoutes from "@/components/subscriber/sale-documents/router";
import AccountRoutes from "@/components/subscriber/accounts/router";
import CustomerRoutes from "@/components/subscriber/customers/router";
import SupplierRoutes from "@/components/subscriber/suppliers/router";
import DriversRoutes from "@/components/subscriber/drivers/router";
import SaleTypesRoutes from "@/components/subscriber/sale-types/router";
import StoreSectionsRoutes from "@/components/subscriber/store-sections/router";
import PriceListRoutes from "@/components/subscriber/price-lists/router";
import IndustryRoutes from "@/components/subscriber/industries/router";
import ClientRequestsRoutes from "@/components/subscriber/client-requests/router";
import ExpensesRoutes from "@/components/subscriber/expenses/router";
import StoresRoutes from "@/components/subscriber/stores/router";
import SubscriberSmsRoutes from "@/components/subscriber/sms/router";
import GeneralSettingsRoutes from "@/components/subscriber/general-settings/router";
import SubscriberPaymentRoutes from "@/components/subscriber/payments/router";
import UsersRoutes from "@/components/subscriber/users/router";
import PosRoutes from "@/components/subscriber/pos/router";
import InventoryRoutes from "@/components/subscriber/inventory/router";
import CheckStockRoutes from "@/components/subscriber/check-stock/router";
import CargoStockRoutes from "@/components/subscriber/cargo-stock/router";
import StockTransferRoutes from "@/components/subscriber/stock-transfer/router";
import SetupRoutes from "@/components/subscriber/setup/router";
import CancelSaleRoutes from "@/components/subscriber/cancel-sale/router";
import TestPrinterRoutes from "@/components/subscriber/test-printer/router";
import OutsourcedRoutes from "@/components/subscriber/outsourced/router";
import CompareRoutes from "@/components/subscriber/compare/router";
import ContainerRoutes from "@/components/subscriber/containers/router";
import ReturnRoutes from "@/components/subscriber/returns/router";
import StockTakingRoutes from "@/components/subscriber/stock-taking/router";
import StockActionsRoutes from "@/components/subscriber/stock-actions/router";

import ProductionRoutes from "@/components/subscriber/production/router";
import GlAccountsRoutes from "@/components/subscriber/gl-accounts/router";

import AccountsTransferRoutes from "@/components/subscriber/accounts-transfers/router";
import JournalEntryRoutes from "@/components/subscriber/journal-entry/router";

import DocumentNumberingRoutes from "@/components/subscriber/document-numbering/router";


import AccountSetupRoutes from "@/components/subscriber/accounts-setup/router";
import AccountBalancesRoutes from "@/components/subscriber/balances/router";

import SystemInitRoutes from "@/components/subscriber/system-init/router";

import SubscriberReportsRoutes from "@/components/subscriber/reports/router";
import SalesReportsRoutes from "@/components/subscriber/reports/sales/router";
import PurchasesReportsRoutes from "@/components/subscriber/reports/purchases/router";

import ProjectReportsRoutes from "@/components/subscriber/reports/projects/router";

import ListReportsRoutes from "@/components/subscriber/reports/lists/router";
import FinancialReportsRoutes from "@/components/subscriber/reports/finance/router";


import CurrencyRoutes from "@/components/subscriber/currencies/router";
import RepairsRoutes from "@/components/subscriber/repairs/router";


import GasRoutes from "@/components/subscriber/gas/router";


import FreightRoutes from "@/components/subscriber/freight/router";


import PaymentTermsRoutes from "@/components/subscriber/payment-terms/router";


import EditingRoutes from "@/components/subscriber/editing/router";


import RegionRoutes from "@/components/subscriber/regions/router";


import LipaPolePoleRoutes from "@/components/subscriber/lipa-pole-pole/router";


import ProjectsRoutes from "@/components/subscriber/projects-management/router";


import ShortcutPagesRoutes from "@/components/subscriber/shortcut-pages/router";

import ExpiryNotice from "@/components/admin/expiry/index.vue";
import SwitchShop from "@/components/admin/switch/index.vue";
import SwitchCompany from "@/components/admin/switch/company.vue";
import Onboarding from "@/components/admin/onboarding/index.vue";

import DataExportRoutes from "@/components/subscriber/data-export/router";
import MergeProductsRoutes from "@/components/subscriber/merge-products/router";
import BillingRoutes from "@/components/subscriber/billing/router";

import DamagesRoutes from "@/components/subscriber/damages/router";

// exports module
import ExportRoutes from "@/components/subscriber/exports-module/router";

import GeneralLayout from "@/layout/GeneralLayout";
import ShopLayout from "@/layout/subscriberLayout";
import AdminLayout from "@/layout/adminLayout";
import OrderLayout from "@/layout/OrderLayout";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginPage,
    },
    {
      path: "/login",
      name: "LoginRoute",
      component: Login,
    },
    {
      path: "/customer/login",
      component: CustomerLogin,
    },
    {
      path: "/reset/password",
      name: "PasswordResetRoute",
      component: ResetPassword,
    },
    {
      path: "/register",
      name: "RegistrationRoute",
      component: Register,
    },
    {
      path: "/register/:company",
      component: CustomerRegister,
    },
    {
      path: "/ordering",
      component: OrderLayout,
      children: [
        {
          path: "/customer/order",
          component: CreateOrder,
        },
        {
          path: "/customer/order/:id",
          component: CategoryProducts,
        },
        {
          path: "/customer/order/submit/new",
          component: SubmitOrder,
        },
      ],
    },
    {
      path: "/pending/orders",
      component: OrderLayout,
      children: [
        {
          path: "/pending/orders",
          component: PendingOrders,
        },
      ],
    },
    {
      path: "/customer-order/:id",
      component: OrderLayout,
      children: [
        {
          path: "/customer-order/:id",
          component: CustomerOrderView,
        },
      ],
    },
    {
      path: "/onboarding",
      component: GeneralLayout,
      children: [
        {
          path: "/",
          component: Onboarding,
        },
      ],
    },
    {
      path: "/inactive-account",
      component: GeneralLayout,
      children: [
        {
          path: "/",
          component: ExpiryNotice,
        },
      ],
    },
    {
      path: "/switch-store",
      component: GeneralLayout,
      children: [
        {
          path: "/",
          component: SwitchShop,
        },
      ],
    },
    {
      path: "/switch-company",
      component: GeneralLayout,
      children: [
        {
          path: "/",
          component: SwitchCompany,
        },
      ],
    },
    // subscriber layout
    {
      path: "/admin",
      component: AdminLayout,
      children: [
        {
          path: "/admin/dashboard",
          name: "AdminDashboard",
          component: AdminDashboard,
        },
        ...SubscribersRoutes,
      ],
    },
    {
      path: "/",
      component: ShopLayout,
      beforeEnter: (to, from, next) => {
        const tokenStatus = localStorage.token;
        if (tokenStatus == undefined || tokenStatus == null) {
          next("/login");
        } else {
          next();
        }
      },
      children: [
        {
          path: "/subscriber/dashboard",
          name: "subscriberDashboard",
          component: SubscriberDashboard,
        },
        // subscriber routes
        ...DamagesRoutes,
        ...LipaPolePoleRoutes,
        ...ShortcutPagesRoutes,
        ...RegionRoutes,
        ...RepairsRoutes,
        ...ListReportsRoutes,
        ...PurchasesReportsRoutes,
        ...SalesReportsRoutes,
        ...TestPrinterRoutes,
        ...StoresRoutes,
        ...ProductsRoutes,
        ...PurchasesRoutes,
        ...SaleDocumentsRoutes,
        ...AccountRoutes,
        ...CustomerRoutes,
        ...SupplierRoutes,
        ...PriceListRoutes,
        ...IndustryRoutes,
        ...ClientRequestsRoutes,
        ...ExpensesRoutes,
        ...SubscriberSmsRoutes,
        ...GeneralSettingsRoutes,
        ...SubscriberPaymentRoutes,
        ...UsersRoutes,
        ...PosRoutes,
        ...InventoryRoutes,
        ...CheckStockRoutes,
        ...CargoStockRoutes,
        ...StockTransferRoutes,
        ...SubscriberReportsRoutes,
        ...SetupRoutes,
        ...CancelSaleRoutes,
        ...EditingRoutes,
        ...AccountsTransferRoutes,
        ...AccountBalancesRoutes,
        ...FreightRoutes,
        ...PaymentsRoutes,
        ...AllShopsRoutes,
        ...OutsourcedRoutes,
        ...CompareRoutes,
        ...ContainerRoutes,
        ...ReturnRoutes,
        ...StockTakingRoutes,
        ...StockActionsRoutes,
        ...ProductionRoutes,
        ...AccountSetupRoutes,
        ...GlAccountsRoutes,
        ...JournalEntryRoutes,
        ...DataExportRoutes,
        ...DocumentNumberingRoutes,
        ...SystemInitRoutes,
        ...CurrencyRoutes,
        ...MergeProductsRoutes,
        ...DriversRoutes,
        ...GasRoutes,
        ...BillingRoutes,
        ...PaymentTermsRoutes,
        ...ProjectsRoutes,
        ...SaleTypesRoutes,
        ...StoreSectionsRoutes,
        ...FinancialReportsRoutes,
        ...ProjectReportsRoutes,
        ...ExportRoutes,
      ],
    },
  ],
});
